import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CircleCheckBig, Sparkles } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Logo } from "@/components/Logo";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const { t } = useLang();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("failed"); return; }
    const poll = async () => {
      if (attempts.current >= 8) { setStatus("failed"); return; }
      attempts.current += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") { await checkAuth(); setStatus("paid"); return; }
        if (["failed", "expired"].includes(res.data.payment_status)) { setStatus("failed"); return; }
      } catch (e) {}
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-decide-canvas flex flex-col items-center justify-center px-6 text-center">
      {status === "checking" && (
        <>
          <Logo size="lg" />
          <p className="mt-6 text-decide-slate animate-pulse" data-testid="payment-checking">{t("payment.checking")}</p>
        </>
      )}
      {status === "paid" && (
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="flex flex-col items-center" data-testid="payment-success">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-decide-forestLight">
            <CircleCheckBig size={40} className="text-decide-forest" />
          </div>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-decide-forestLight px-3 py-1 text-xs font-bold text-decide-forest"><Sparkles size={13} /> DECIDE PRO</div>
          <h1 className="mt-4 text-3xl font-light tracking-tight text-decide-ink">{t("payment.successTitle")}</h1>
          <p className="mt-2 text-decide-slate">{t("payment.successSub")}</p>
          <button data-testid="success-continue" onClick={() => navigate("/app")} className="btn-accent mt-8">{t("payment.startDeciding")}</button>
        </motion.div>
      )}
      {status === "failed" && (
        <div className="flex flex-col items-center" data-testid="payment-failed">
          <h1 className="text-2xl font-medium text-decide-ink">{t("payment.failedTitle")}</h1>
          <p className="mt-2 text-decide-slate">{t("payment.failedSub")}</p>
          <button onClick={() => navigate("/pricing")} className="btn-secondary mt-6">{t("payment.backPricing")}</button>
        </div>
      )}
    </div>
  );
}
